export default __webpack_public_path__ + "static/media/ilus9.d5e1d05e.jpeg";